__turbopack_context__.v({
  "iconbutton": "IconButton-module-sass-module__K0N6Ka__iconbutton",
  "iconbutton--accent": "IconButton-module-sass-module__K0N6Ka__iconbutton--accent",
  "iconbutton--children": "IconButton-module-sass-module__K0N6Ka__iconbutton--children",
  "iconbutton--danger": "IconButton-module-sass-module__K0N6Ka__iconbutton--danger",
  "iconbutton--mini": "IconButton-module-sass-module__K0N6Ka__iconbutton--mini",
  "iconbutton--primary": "IconButton-module-sass-module__K0N6Ka__iconbutton--primary",
  "iconbutton--success": "IconButton-module-sass-module__K0N6Ka__iconbutton--success",
  "iconbutton--transparent": "IconButton-module-sass-module__K0N6Ka__iconbutton--transparent",
  "iconbutton__badge": "IconButton-module-sass-module__K0N6Ka__iconbutton__badge",
});
